// extracted by mini-css-extract-plugin
module.exports = {"logo":"SideMenu_logo__33ZE0","menu":"SideMenu_menu__zG91v","menu-list":"SideMenu_menu-list__3oXUh","selected":"SideMenu_selected__d_dV9"};